import { createContext } from 'react'
import { type UserAgentContextType } from './types'

const UserAgentContext = createContext<UserAgentContextType>(null)

export {
  UserAgentContext
}
